import staffCheckin from "@/views/publicWelfareStaff/checkin.vue"; //登陆
import staffMenu from "@/views/publicWelfareStaff/menu.vue"; //菜单
import staffMsg from "@/views/publicWelfareStaff/msg.vue"; //提示信息
import patientDetial from "@/views/publicWelfareStaff/patientDetial.vue"; //患者详情
import patientDetails from "@/views/publicWelfareStaff/patientDetails.vue"; //患者详细信息

//患者管理
import patientManage from "@/views/publicWelfareStaff/patientManage/index.vue"; //患者管理首页
import phaseCheck from "@/views/publicWelfareStaff/patientManage/phaseCheck.vue"; //阶段查看
// import patientLogin from "@/views/publicWelfareStaff/patientManage/patientLogin.vue"; //患者注册
import patientOcr from "@/views/publicWelfareStaff/patientManage/patientOcr.vue"; //上传身份证
import addPatient from "@/views/publicWelfareStaff/patientManage/addPatient.vue"; //新增患者(填写资料)
import patientUpload from "@/views/publicWelfareStaff/patientManage/patientUpload.vue"; //上传资料
import patientUploadItem from "@/views/publicWelfareStaff/patientManage/patientUploadItem.vue"; //上传资料详情
import patientAppointment from "@/views/publicWelfareStaff/patientManage/patientAppointment.vue"; //预约用药
import PatientChooseTime from "@/views/publicWelfareStaff/patientManage/PatientChooseTime.vue"; //开启下一阶段




// 个人中心
import personalCenter from "@/views/publicWelfareStaff/personalCenter/index.vue"; //阶段查看

//消息推送
import newsFeed from "@/views/publicWelfareStaff/newsFeed/index.vue"; //消息推送
import addService from "@/views/publicWelfareStaff/newsFeed/addService.vue"; //新增患者服务

//患者服务
import patientServices from "@/views/publicWelfareStaff/patientServices/index.vue"; //新增患者服务
// import addService from "@/views/publicWelfareStaff/newsFeed/addService.vue"; //新增患者服务

//用药回访
import returnVisit from "@/views/publicWelfareStaff/returnVisit/index.vue"; //用药回访
import visitDetail from "@/views/publicWelfareStaff/returnVisit/visitDetail.vue"; //用药回访详情

//医护拜访
import medicalVisit from "@/views/publicWelfareStaff/medicalVisit/index.vue"; //医护拜访
import addVisit from "@/views/publicWelfareStaff/medicalVisit/addVisit.vue"; //新增医护拜访
import medicalVisitDetail from "@/views/publicWelfareStaff/medicalVisit/medicalVisitDetail.vue"; //医护拜访详情


//监督发药
import superviseDrugDistribution from "@/views/publicWelfareStaff/superviseDrugDistribution/index.vue"; //医护拜访
import newSupervise from "@/views/publicWelfareStaff/superviseDrugDistribution/newSupervise.vue"; //医护拜访
import superviseDetail from "@/views/publicWelfareStaff/superviseDrugDistribution/superviseDetail.vue"; //医护拜访
import predictIds from "@/views/publicWelfareStaff/superviseDrugDistribution/predictIds.vue"; //医护拜访


//盘点库存
import inventoryCheck from "@/views/publicWelfareStaff/inventoryCheck/index.vue"; //医护拜访
import inventoryDetail from "@/views/publicWelfareStaff/inventoryCheck/inventoryDetail.vue"; //医护拜访
import addInventory from "@/views/publicWelfareStaff/inventoryCheck/addInventory.vue"; //医护拜访

//服务记录
import serviceRecord from "@/views/publicWelfareStaff/serviceRecord/index.vue"; // 服务记录
import patientList from "@/views/publicWelfareStaff/serviceRecord/patientList.vue"; // 患者列表




const staffRoutes = [
  {
    path: "/publicWelfareStaff/checkin",
    name: "staffCheckin",
    component: staffCheckin,
    meta: {
      title: '公益专员登录'
    }
  },
  {
    path: "/publicWelfareStaff/menu",
    name: "staffMenu",
    component: staffMenu,
    meta: {
      title: '我的主页'
    }
  },

  // 患者管理
  {
    path: "/publicWelfareStaff/patientManage",
    name: "patientManage",
    component: patientManage,
    meta: {
      title: '患者管理'
    }
  },
  {
    path: "/publicWelfareStaff/patientManage/phaseCheck",
    name: "phaseCheck",
    component: phaseCheck,
    meta: {
      title: '阶段查看'
    }
  },
  {
    path: "/publicWelfareStaff/patientManage/addPatient",
    name: "addPatient",
    component: addPatient,
    meta: {
      title: '新增患者'
    }
  },
  {
    path: "/publicWelfareStaff/patientManage/patientOcr",
    name: "patientOcr",
    component: patientOcr,
    meta: {
      title: '立即申请'
    }
  },
  
  // {
  //   path: "/publicWelfareStaff/patientManage/patientLogin",
  //   name: "patientLogin",
  //   component: patientLogin,
  //   meta: {
  //     title: '患者注册'
  //   }
  // },
  {
    path: "/publicWelfareStaff/patientManage/patientUpload",
    name: "patientUpload",
    component: patientUpload,
    meta: {
      title: '上传审核材料'
    }
  },
  {
    path: "/publicWelfareStaff/patientManage/patientUploadItem",
    name: "patientUploadItem",
    component: patientUploadItem,
    meta: {
      title: '电子预审核'
    }
  },
  {
    path: "/publicWelfareStaff/patientManage/patientAppointment",
    name: "patientAppointment",
    component: patientAppointment,
    meta: {
      title: '预约用药'
    }
  },
  {
    path: "/publicWelfareStaff/patientManage/PatientChooseTime",
    name: "PatientChooseTime",
    component: PatientChooseTime,
    meta: {
      title: '开启下一阶段'
    }
  },

  //消息推送
  {
    path: "/publicWelfareStaff/newsFeed", 
    name: "newsFeed",
    component: newsFeed,
    meta: {
      title: '消息推送'
    }
  },
  {
    path: "/publicWelfareStaff/addService", 
    name: "addService",
    component: addService,
    meta: {
      title: '新增患者服务'
    }
  },
  // { 使用共用页面
  //   path: "/publicWelfareStaff/patientDetails",
  //   name: "patientDetails",
  //   component: patientDetails,
  //   meta: {
  //     title: '详细信息'
  //   }
  // },

  //患者服务
  {
    path: "/publicWelfareStaff/patientServices", 
    name: "patientServices",
    component: patientServices,
    meta: {
      title: '患者服务'
    }
  },

  //服务记录
  {
    path: "/publicWelfareStaff/serviceRecord", 
    name: "serviceRecord",
    component: serviceRecord,
    meta: {
      title: '服务记录'
    }
  },
  {
    path: "/publicWelfareStaff/serviceRecord/patientList",  // 患者列表 
    name: "patientList",
    component: patientList, 
    meta: {
      title: '患者列表'
    }
  },
  
  
  //医护拜访
  {
    path: "/publicWelfareStaff/medicalVisit", 
    name: "medicalVisit",
    component: medicalVisit,
    meta: {
      title: '医护拜访'
    }
  },
  {
    path: "/publicWelfareStaff/medicalVisit/addVisit", 
    name: "addVisit",
    component: addVisit,
    meta: {
      title: '新增医护拜访'
    }
  },
  {
    path: "/publicWelfareStaff/medicalVisit/medicalVisitDetail", 
    name: "medicalVisitDetail",
    component: medicalVisitDetail,  //医护拜访详情
    meta: {
      title: '医护拜访'
    }
  },

  //盘点库存
  {
    path: "/publicWelfareStaff/inventoryCheck", 
    name: "inventoryCheck",
    component: inventoryCheck,
    meta: {
      title: '盘点库存'
    }
  },
  {
    path: "/publicWelfareStaff/inventoryCheck/inventoryDetail", 
    name: "inventoryDetail",
    component: inventoryDetail,
    meta: {
      title: '盘点库存详情'
    }
  },
  {
    path: "/publicWelfareStaff/inventoryCheck/addInventory", 
    name: "addInventory",
    component: addInventory,
    meta: {
      title: '新增盘点库存'
    }
  },

  //监督发药
  {
    path: "/publicWelfareStaff/superviseDrugDistribution", 
    name: "superviseDrugDistribution",
    component: superviseDrugDistribution,
    meta: {
      title: '监督发药'
    }
  },
  {
    path: "/publicWelfareStaff/superviseDrugDistribution/newSupervise", 
    name: "newSupervise",
    component: newSupervise,
    meta: {
      title: '新增监督发药'
    }
  },
  {
    path: "/publicWelfareStaff/superviseDrugDistribution/superviseDetail", 
    name: "superviseDetail",
    component: superviseDetail,
    meta: {
      title: '监督发药详情'
    }
  },
  
  {
    path: "/publicWelfareStaff/superviseDrugDistribution/predictIds", 
    name: "predictIds",
    component: predictIds,
    meta: {
      title: '选择领药人'
    }
  },
  //用药回访
  {
    path: "/publicWelfareStaff/returnVisit", 
    name: "returnVisit",
    component: returnVisit,
    meta: {
      title: '用药回访'
    }
  },
      // 用药回访详情页
  {
    path: "/publicWelfareStaff/returnVisit/visitDetail", 
    name: "visitDetail",
    component: visitDetail,
    meta: {
      title: '用药回访'
    }
  },

  // 个人中心
  {
    path: "/publicWelfareStaff/personalCenter", 
    name: "personalCenter",
    component: personalCenter,
    meta: {
      title: '我的'
    }
  },

  //共用页面
  {
    path: "/publicWelfareStaff/msg",
    name: "staffMsg",
    component: staffMsg,
    meta: {
      title: '注册成功'
    }
  },
  {
    path: "/publicWelfareStaff/patientDetial",
    name: "patientDetial",
    component: patientDetial,
    meta: {
      title: '患者详情'
    }
  },

  {
    path: "/publicWelfareStaff/patientDetails",
    name: "patientDetails",
    component: patientDetails,
    meta: {
      title: '详细信息'
    }
  },
]


export default staffRoutes;